<style lang="scss" scoped>
/deep/ .ivu-carousel-arrow{
    background-color:rgba(0,0,0,.5);
    color: #fff;
    font-size: 2em;
}
/deep/ .ivu-carousel-track.higher{
    display: flex;
    align-items: center;
}
.cont img{
    display:block;
    padding: 0 70px;
    margin:0 auto;
    max-width:100%;
    height: 600px;
}

</style>
<template>
    <div>
        <Carousel v-model="currentImge" arrow="always">
            <CarouselItem v-for="(item,index) in imgData" :key="index">
                <div class="cont">
                    <a :href="item" target="_blank">
                        <img :src="`${item}?image_process=image/resize,w_800&x-oss-process=image/resize,w_800`" />
                    </a>
                </div>
            </CarouselItem>
        </Carousel>
    </div>
</template>

<script>
export default {
    props: ['currentUrl', 'urlList'],
    data () {
        return {
            currentImge: this.currentUrl || 0,
            imgData: this.urlList || [],
        }
    },
    methods: {
    },
    computed: {
    }
}
</script>

<style>

</style>
